import styled from "styled-components";
import { CSSProperties, PropsWithChildren, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { NavBackArrow } from "manifest-components/src/Images/icons";

export const StyledBoxContainer = styled.div`
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  border-radius: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
  padding-left: 15px;
  padding-right: 15px;
  display: inline-block;
  position: relative;
  #backArrow {
    button {
      position: absolute;
      top: 20px;
      left: 20px;
      width: auto;
      svg {
        width: 25px;
        height: 25px;
      }
    }
  }
`;

export const BoxContainer2 = styled.div`
  padding: 55px 30px;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(46, 45, 41, 0.2);
  box-sizing: border-box;
  border-radius: 10px;
`;

export const BoxContainer = (
  props: PropsWithChildren<{ navBackClass?: string; className?: string; style?: CSSProperties }>
) => {
  const { navBackClass } = props;
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setVisible(true);
  }, []);

  return (
    <StyledBoxContainer {...props}>
      <div id="backArrow" className={`box-${navBackClass}`} />
      {visible && props.children}
    </StyledBoxContainer>
  );
};

type NavBackForBoxContainerProps = {
  onClick: (...args: any) => any;
  bindTo: string;
};

export const NavBackForBoxContainer = (props: NavBackForBoxContainerProps) => {
  const { bindTo } = props;
  return ReactDOM.createPortal(
    <button type="button" onClick={props.onClick}>
      <NavBackArrow />
    </button>,
    document.querySelector(`.box-${bindTo}`)!
  );
};
